







import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class CellSwitch extends Vue {
    @Prop({type: Boolean, default: false}) private value?: boolean;
    @Prop(String) private name!: string;

    private isChecked: any = false;
    private created() {
        this.isChecked = this.value;
    }

    @Emit('change')
    private onChange(checked: boolean) {
        return checked;
    }

}
